























import { Component } from "vue-property-decorator";
import Vue from "vue";

import AppLayout from "./layouts/AppLayout.vue";
import SimpleLayout from "./layouts/SimpleLayout.vue";
import SnackBarService from "./services/appSnackbar.service";

import BackToTop from "vue-backtotop";

@Component({
  components: {
    "app-layout": AppLayout,
    "simple-layout": SimpleLayout,
    BackToTop
  }
})
export default class App extends Vue {
  appSnackBar = SnackBarService.getModel();

  beforeCreate() {
    this.$i18n.locale = this.$store.getters.locale;
  }

  get darkMode() {
    return this.$store.state.ui.darkMode;
  }

  get layout() {
    if (this.$route.meta.layout) {
      this.$store.commit("SET_LAYOUT", this.$route.meta.layout + "-layout");
    } else if (this.$store.getters.layout !== "app-layout") {
      this.$store.commit("SET_LAYOUT", "app-layout");
    }
    return this.$store.getters.layout;
  }
}
